<template>
  <div class="pa-2">
    <h4 class="settings-h4">Guest Accounts</h4>
    <div class="wrapper-2 pa-4 mb-4 pos-relative">
      <!--REQUIE TWO STEP AUTH-->
      <!-- add following line into the v-checkbox, to notify the user that there are guests which don't have mobile number.  -->
      <!-- @change="allowTwoStepChanged" -->
      <!-- <v-checkbox
        v-model="organization.casualUsersDefinitions.isTwoStep"
        :disabled="
          !organization.casualUsersDefinitions.isActive ||
          organization.status !== 0
        "
        class="pa-0 ma-0 mb-2"
        label="Email Authentication"
        hide-details
      ></v-checkbox> -->
      <!-- <div class="d-flex py-0">
        <div class="left">
          <span class="radio-group-label mr-2 mb-0">Email Authentication:</span>
        </div>
        <div class="right">
          <v-radio-group
            v-model="
              organization.casualUsersDefinitions.notificationMethodForTwoStep
            "
            row
            hide-details
            class="ma-0"
          >
            <v-radio :value="1" label="Email"></v-radio>
            <v-radio :value="2" label="SMS" @click="allowTwoStepChanged"></v-radio>
            <v-radio :value="0" label="None"></v-radio>
          </v-radio-group>
        </div>
      </div> -->
      <!-- <CasualLanguage :organization="organization" /> -->
<CasualsAuth
        :originalMethod="
          organization.casualUsersDefinitions.notificationMethodForTwoStep
        "
        @method-changed="val =>
          (organization.casualUsersDefinitions.notificationMethodForTwoStep = val)"
        @allow-two-step-changed="allowTwoStepChanged"
      />
      <TimezoneOffset
        :currentTimezoneOffset="
          organization.casualUsersDefinitions.timezoneOffsetInMinutes
        "
        :disabled="false"
        label="Timezone offset in folder names of guests"
        @offset-type-changed="offsetTypeChanged"
      />

      <!--DURATION - FILES LIFE TIME -->
      <CasualFilesLifeTime :organization="organization" />

      <!--POLICIES -->
      <span
        class="light-text"
        
      >
        Policies:
      </span>
      <div class="d-flex mt-2">
        <!--POLICY FOR FILES GET IN -->
        <v-select
          v-model="organization.casualUsersDefinitions.policyIn"
          :items="computedPolicies"
          
          class="px-0 mx-3 py-0"
          label="Incoming Files"
          style="max-width: 200px"
          hide-details
        >
        </v-select>
        <!--POLICY FOR FILES GET OUT -->
        <v-select
          v-model="organization.casualUsersDefinitions.policyOut"
          :items="computedPolicies"
          
          class="px-0 mx-3 py-0"
          label="Outgoing Files"
          style="max-width: 200px"
          hide-details
        >
        </v-select>
      </div>

      <LicensesTable
        :casualsLicense="casualLicense"
        :allowCasualsChanged="allowCasualsChanged"
      />

      <OnlineHelp
        page="settings"
        section="casualSettings"
        title="Guest Accounts"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

//Base components
import OnlineHelp from '@/components/BaseComponents/OnlineHelp/OnlineHelp.vue'
import CasualFilesLifeTime from './Childrens/CasualFilesLifeTime/CasualFilesLifeTime.vue'
import CasualLanguage from './Childrens/CasualLanguage/CasualLanguage.vue'
import LicensesTable from './Childrens/LicensesTable/LicensesTable.vue'
import TimezoneOffset from '@/components/BaseComponents/CasualCommonComponents/TimezoneOffset.vue'
import { api } from '@/config'
import { alertDialog } from '@/utils'
import CasualsAuth from '@/components/BaseComponents/CasualCommonComponents/CasualsAuth.vue'

export default {
  name: 'CasualUserSettings',
  props: {
    organization: Object,
    loggedUser: Object,
    actionType: String,
    allowCasualsChanged: Function,
  },
  computed: {
    ...mapGetters(['policies', 'language']),
    computedPolicies() {
      if (this.actionType === 'edit') return this.policies
      return []
    },
    casualLicense() {
      return this.organization.allowedLicenses.find(el => el.type === 'Casual')
    },
  },
  methods: {
    ...mapActions(['GET_POLICIES']),
    ...mapMutations(['SET_PROCESSING']),
    async allowTwoStepChanged(val) {
      console.log('val: ', val)
      //check if all casuals have phone number for 2fa
      if (!val) return

      try {
        this.SET_PROCESSING(true)
        const isAllCasualsHavePhoneRes = await api.get(
          'casuals/is-all-have-phone-number'
        )

        if (isAllCasualsHavePhoneRes.status !== 200) throw Error

        if (!isAllCasualsHavePhoneRes.data.isAllHavePhoneNumber) {
          alertDialog(
            this,
            `<div style="direction: ltr"><p>Attention,</p><p>Not all the guest users in your host have a mobile number.</p><p>The Two-Factor Authentication settings will only apply on guest users with a mobile number.</p><p>Existing guest users without a mobile number will not be verified with Two-Factor Authentication until a mobile number is provided for them.</p><p>For new guest users, a mobile number will be mandatory.</p></div>`,
            'Confirm'
          )
          // this.organization.casualUsersDefinitions.isTwoStep = false
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.SET_PROCESSING(false)
      }
    },
    offsetTypeChanged(val) {
      this.organization.casualUsersDefinitions.timezoneOffsetInMinutes = val
    },
  },
  async created() {
    await this.GET_POLICIES(this.organization.organizationId)
  },
  components: {
    OnlineHelp,
    CasualFilesLifeTime,
    CasualLanguage,
    LicensesTable,
    TimezoneOffset,
    CasualsAuth,
  },
}
</script>

